import React, { useState, useContext, memo } from 'react';
import { Link } from 'react-router-dom';
import { UncontrolledPopover, PopoverBody } from 'reactstrap';
import { Typography,  Grid, Avatar, Dialog, DialogContent, DialogActions, Button, Slide } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import { history } from '../../apiAuthorization/history';
import { Theme } from '../contexts/themeContext.js';
import { Context } from "../contexts/siteContext.js";
import { Modules } from '../contexts/modulesContext';
import { GlobalTheme } from "../../layouts/theme";
import MenuIcon from '@material-ui/icons/Menu';
import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
        overflowY: 'auto'
    },
    pop: {
        backgroundColor: 'inherit',
        width: 'max-content',
        boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)'
    },
    smallMenulink: {
        marginTop: '5px',
        fontSize: '12px',
        color: '#0C76D8',
        fontWeight: '500'
    },
    dialog: {
        borderRadius: 10
    },
    button: {
        borderRadius: 5,
        textTransform: "none",
        padding: 5
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const SmallMenu = (props) => {
    const classes = useStyles();
    const { theme } = useContext(Theme);
    const { defaultSite } = useContext(Context);
    const { modules, trainingMode } = useContext(Modules);
    const [pathName, setPathName] = useState("");
    const [saveConfirmOpen, setSaveConfirmOpen] = useState(false);
    const moduleName = props.moduleName;
    const currentTheme = GlobalTheme[theme];

    const isAuthorized = title => {
        if (title === "TeamPRO") {
            if (defaultSite.IntegratedSystem.TaskMGMTSystemId === null || defaultSite.IntegratedSystem.TaskMGMTSystemId === "0")
                return false;
            else
                return true;
        }
        else if (title === "Coach" || title === "SafetyCoaching") {
            if (defaultSite.IntegratedSystem.TeamCoachId === null || defaultSite.IntegratedSystem.TeamCoachId === "0")
                return false;
            else
                return true;
        }
        else
            return true;
    };

    const linkClicked = (e, path) => {
        if (props.modified) {
            e.preventDefault();
            setPathName(path);
            setSaveConfirmOpen(true);
        }
        else if (props.closeDialog) {
            props.closeDialog();
        }
        else {
            history.push({ pathname: "/" + path });
        }
    };

    const cancel = () => {
        if (props.closeDialog) {
            props.closeDialog();
            history.push({ pathname: "/" + pathName });
        }
        else
            history.push({ pathname: "/" + pathName });
    };

    const triggerSave = () => {
        setSaveConfirmOpen(false);
        if (props.saveCallback) {
            props.saveCallback();
        }
    };

    const SmallMenuItem = propsSMI => {
        let module = propsSMI.title;

        if (module === "Staffing") {
            return (
                <Link to={{ pathname: "/StaffingList" }} onClick={(e) => linkClicked(e, "StaffingList")}>
                    <Avatar style={{ backgroundColor: currentTheme.secondary }}>S</Avatar>
                    <Typography className={classes.smallMenulink}>Staffing</Typography>
                </Link>
            )
        }
        else if (module === "SafetyCoaching") {
            return (
                <Link to={{ pathname: "/SafetyCoachingList" }} onClick={(e) => linkClicked(e, "SafetyCoachingList")}>
                    <Avatar style={{ backgroundColor: currentTheme.secondary }}>SC</Avatar>
                    <Typography className={classes.smallMenulink}>Safety Coaching</Typography>
                </Link>
            )
        }
        else if (module === "Journal") {
            return (
                <Link to={{ pathname: "/JournalList" }} onClick={(e) => linkClicked(e, "JournalList")}>
                    <Avatar style={{ backgroundColor: currentTheme.secondary }}>J</Avatar>
                    <Typography className={classes.smallMenulink}>Journal</Typography>
                </Link>
            )
        }
        else if (module === "Huddle") {
            return (
                <Link to={{ pathname: "/HuddleList" }} onClick={(e) => linkClicked(e, "HuddleList")}>
                    <Avatar style={{ backgroundColor: currentTheme.secondary }}>H</Avatar>
                    <Typography className={classes.smallMenulink}>Huddle</Typography>
                </Link>
            )
        }
        else if (module === "Round") {
            return (
                <Link to={{ pathname: "/Rounds" }} onClick={(e) => linkClicked(e, "Rounds")}>
                    <Avatar style={{ backgroundColor: currentTheme.secondary }}>R</Avatar>
                    <Typography className={classes.smallMenulink}>Round</Typography>
                </Link>
            )
        }
        else if (module === "Coach") {
            return (
                <Link to={{ pathname: "/TeamCoachList" }} onClick={(e) => linkClicked(e, "TeamCoachList")}>
                    <Avatar style={{ backgroundColor: currentTheme.secondary }}>C</Avatar>
                    <Typography className={classes.smallMenulink}>Coach</Typography>
                </Link>
            )
        }
        else if (module === "PatientSitting") {
            return (
                <Link to={{ pathname: "/PatientSittingList" }} onClick={(e) => linkClicked(e, "PatientSittingList")}>
                    <Avatar style={{ backgroundColor: currentTheme.secondary }}>PO</Avatar>
                    <Typography className={classes.smallMenulink}>Patient Observation</Typography>
                </Link>
            )
        }
        else if (module === "RDOAccountVisitation") {
            return (
                <Link to={{ pathname: "/RdoAccountVisitationList" }} onClick={(e) => linkClicked(e, "RdoAccountVisitationList")}>
                    <Avatar style={{ backgroundColor: currentTheme.secondary }}>AV</Avatar>
                    <Typography className={classes.smallMenulink}>Account Visitation</Typography>
                </Link>
            )
        }
        else if (module === "VisitationEVS") {
            return (
                <Link to={{ pathname: "/VisitationEVSList" }} onClick={(e) => linkClicked(e, "VisitationEVSList")}>
                    <Avatar style={{ backgroundColor: currentTheme.secondary }}>VE</Avatar>
                    <Typography className={classes.smallMenulink}>Visitation EVS</Typography>
                </Link>
            )
        }
        else if (module === "Recovery") {
            return (
                <Link to={{ pathname: "/RecoveryEVSList" }} onClick={(e) => linkClicked(e, "RecoveryEVSList")}>
                    <Avatar style={{ backgroundColor: currentTheme.secondary }}>RE</Avatar>
                    <Typography className={classes.smallMenulink}>Recovery EVS</Typography>
                </Link>
            )
        }
        else if (module === "TeamPRO") {
            return (
                <Link to={{ pathname: "/TeamProList" }} onClick={(e) => linkClicked(e, "TeamProList")}>
                    <Avatar style={{ backgroundColor: currentTheme.secondary }}>TP</Avatar>
                    <Typography className={classes.smallMenulink}>TeamPRO</Typography>
                </Link>
            )
        }
        else {
            return <></>
        }
    };

    return (
        <div style={{ paddingLeft: '15px' }}>
            <IconButton id="PopoverSmallMenu"  color="inherit" aria-label="Menu" disabled={trainingMode}>
                <MenuIcon />
            </IconButton>
           
            <UncontrolledPopover trigger="legacy" placement="bottom" target="PopoverSmallMenu" className="smallMenuContainer">
                <PopoverBody style={{ color: currentTheme.text }}>
                    {(modules.length !== 1) &&
                        <Grid container spacing={1} direction="row">
                            {modules.map((item, index) => (
                                (moduleName !== item.title && isAuthorized(item.title)) &&
                                <Grid item xs={4} key={index} align="center">
                                    <SmallMenuItem title={item.title} />
                                </Grid>
                            ))}
                        </Grid>
                    }
                </PopoverBody>
            </UncontrolledPopover>
            <Dialog open={saveConfirmOpen}
                classes={{ paper: classes.dialog }}
                TransitionComponent={Transition}>
                <DialogContent dividers>
                    <Typography variant="h6" style={{ textTransform: "none" }}>{"Do you wish to save the changes to this record before leaving the module?"}</Typography>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained"
                        color="primary"
                        size="small"
                        style={{ background: currentTheme.secondary, width: "80px" }}
                        startIcon={<SaveIcon />}
                        onClick={triggerSave}
                    >
                        Save
                    </Button>
                    <Button variant="contained"
                        color="secondary"
                        size="small"
                        style={{ width: "230px", marginRight: "10px" }}
                        startIcon={<CancelIcon />}
                        onClick={cancel}
                        autoFocus
                    >
                        Continue without saving
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default memo(SmallMenu);
